var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFitur4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#EFF3FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 32.5L21.9683 40.3732C22.0237 40.5947 22.0513 40.7054 22.0841 40.802C22.404 41.7464 23.2544 42.4104 24.2482 42.4917C24.3499 42.5 24.464 42.5 24.6922 42.5C24.9781 42.5 25.121 42.5 25.2413 42.4883C26.4312 42.3729 27.3729 41.4313 27.4883 40.2414C27.5 40.121 27.5 39.9781 27.5 39.6922V21.875M38.125 31.875C40.5412 31.875 42.5 29.9163 42.5 27.5C42.5 25.0838 40.5412 23.125 38.125 23.125M27.8125 21.875H23.125C20.0184 21.875 17.5 24.3934 17.5 27.5C17.5 30.6066 20.0184 33.125 23.125 33.125H27.8125C30.0205 33.125 32.7216 34.3086 34.8054 35.4446C36.021 36.1073 36.6289 36.4386 37.027 36.3898C37.3961 36.3446 37.6753 36.1789 37.8916 35.8764C38.125 35.5502 38.125 34.8975 38.125 33.5922V21.4079C38.125 20.1025 38.125 19.4498 37.8916 19.1236C37.6753 18.8211 37.3961 18.6554 37.027 18.6102C36.6289 18.5614 36.021 18.8928 34.8054 19.5555C32.7216 20.6914 30.0205 21.875 27.8125 21.875Z",
    stroke: "#3375B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitur4);
export default __webpack_public_path__ + "static/media/fitur4.283f1d4d5ed92fe7b856fa11699698ab.svg";
export { ForwardRef as ReactComponent };